<template>
<div>
  <section class="content-header">
      <div class="row">
          <div class="col-xs-9">
              <h1>{{$t('company.list')}}</h1>
          </div>
          <div class="col-xs-3">
              <router-link :to="{ name: 'CompanyCreate' }" class="btn btn-primary pull-right">{{$t('company.add')}}</router-link>
          </div>
      </div>
  </section>

  <section class="content">
    <div class="box box-primary">
      <div class="box-body">
        <item-list-errors :entity="'company'"></item-list-errors>

        <api-table
                :entity="'Company'"
                :route="'companies'"
                :path="'company'"
                :filterable="filterable"
                :customFilters="customFilters"
                :sortable="sortable"
                :columns="columns"
                :columnsClasses="columnsClasses"
                :templates="templates"
        >
          <template slot="filter__labels.id">
            <labels-filter></labels-filter>
          </template>
        </api-table>
      </div>
    </div>
  </section>
</div>
</template>

<script>
import ItemListErrors from '../layout/errors/ItemListErrors'
import ApiTable from '../ApiTable'
import columnContacts from './../../table/ColumnContacts'
import columnCode from './../../table/ColumnCode'
import columnLabels from './../../table/ColumnLabels'
import columnAddressCountry from './../../table/ColumnAddressCountry'
import columnAddressCity from './../../table/ColumnAddressCity'
import columnAddressPostCode from './../../table/ColumnAddressPostCode'
import LabelsFilter from '../filters/LabelsFilter'

export default {
  components: {LabelsFilter, ItemListErrors, ApiTable},
  data: function () {
    return {
      columns: ['code', 'name', 'contacts.value', 'contactPerson', 'country.name', 'city.name', 'postCode', 'labels.id'],
      filterable: ['code', 'name', 'contacts.value', 'contactPerson', 'country.name', 'city.name', 'postCode'],
      customFilters: ['labels.id'],
      sortable: ['code', 'name', 'contactPerson'],
      columnsClasses: {contactPerson: 'clients-contact'},
      templates: {
        'contacts.value': columnContacts,
        'addresses.country.name': columnAddressCountry,
        'addresses.city.name': columnAddressCity,
        'addresses.postCode': columnAddressPostCode,
        'labels.id': columnLabels,
        'code': columnCode,
      }
    }
  },
}
</script>